// extracted by mini-css-extract-plugin
export default {"main":"CollapsibleDiv_main__RBRiO","title":"CollapsibleDiv_title__U6d1S"};